import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdAttachFile, MdClose, MdDelete, MdDrafts, MdFileCopy, MdFilePresent, MdOutlineDrafts, MdSave, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { MAX_FILE_SIZE, web_url, WORD_LIMIT } from "../../constant";

function ResearcherEmailCompose({ t, lang }) {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^(?!.*script)[a-z0-9.]{7,}$/i;
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });


    const handleChange = (value) => {
        // console.log(value);
        setEmailcomposeDetails((prev) => ({ ...prev, body: value }))
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    const navigate = useNavigate();
    const recepientArray = ['Translator', 'Teacher', 'Student'];

    const [emailcomposeDetails, setEmailcomposeDetails] = useState(
        {
            threadId: '',
            toRole: '',
            to: '',
            subject: '',
            body: '',
        }
    )
    const [errors, setErrors] = useState(
        {
            noToRole: false,
            noTo: false,
            noBody: false,
            invalidTo: false,
            wordLimitExceeded: false
        }
    )

    const [files, setFiles] = useState([]);
    const mobileFileInputRef = useRef(null);
    const desktopFileInputRef = useRef(null);

    const [showRoleInput, setShowRoleInput] = useState(true)


    const handleFileChange = (e) => {

        if (e.target.files) {
            const fileArray = Array.from(e.target.files); // Convert FileList to array
            const validFiles = fileArray.filter((file) => {

                if (file.size <= MAX_FILE_SIZE) {
                    return true;
                } else {
                    alert(`File "${file.name}" is larger than 5MB and will be skipped.`);
                    return false;
                }
            });

            setFiles((prevFiles) => [...prevFiles, ...validFiles]);
            e.target.value = "";
        }
    };

    const removeFile = (fileToRemove) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    };

    const [isSubjectNew, setIsSubjectNew] = useState(false);
    const [isDraft, setIsDraft] = useState(false)
    const [initialType, setInitialType] = useState('no');
    const [threadId, setThreadId] = useState('no');
    const [messageId, setMessageId] = useState('no');


    useEffect(() => {
        if (localStorage.getItem('threadId')) {
            const mailRequest = JSON.parse(localStorage.getItem('threadId'));
            if (mailRequest.type === "new") {
                setInitialType("new");
                setIsDraft(false);
                setIsSubjectNew(true);
                setEmailcomposeDetails({
                    threadId: '',
                    toRole: '',
                    to: '',
                    subject: '',
                    body: '',
                })
            } else if (mailRequest.type === "old") {
                setInitialType("old");
                setIsDraft(false);
                setIsSubjectNew(false);
                setEmailcomposeDetails((prev) => ({
                    ...prev,
                    subject: mailRequest.subject.trim() !== "" ? `${mailRequest.subject}` : " ",
                    threadId: mailRequest.threadId,
                    to: mailRequest.to,
                    toRole: 'Teacher'
                }))
                setShowRoleInput(false)
            }
        } else {
            setInitialType("no");
            setIsDraft(false);
            setIsSubjectNew(true);
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setShowRoleInput(true)
        }
    }, [localStorage.getItem('threadId')]);

    useEffect(() => {
        if (localStorage.getItem('threadId')) {
            const mailRequest = JSON.parse(localStorage.getItem('threadId'));
            if (mailRequest.type === "draft") {
                setInitialType("draft");
                setThreadId(mailRequest.threadId);
                setMessageId(mailRequest.messageId);
                setIsDraft(true);
                setIsSubjectNew(true);
                setShowRoleInput(true);
                setFiles(mailRequest.attachments || [])
                setEmailcomposeDetails((prev) => ({
                    ...prev,
                    subject: mailRequest.subject.trim() !== "" ? `${mailRequest.subject}` : " ",
                    threadId: mailRequest.threadId,
                    to: mailRequest.to,
                    body: mailRequest.body,
                    toRole: ''
                }))
                let thread_id = mailRequest.threadId;
                let message_id = mailRequest.messageId;


            }
        }
    }, [localStorage.getItem('threadId')])

    const handleSend = () => {
        let newErrors = []

        const strippedText = emailcomposeDetails.body.replace(/<[^>]*>/g, "").trim();
        newErrors.noBody = !strippedText;
        newErrors.noTo = !emailcomposeDetails.to;
        newErrors.noToRole = !emailcomposeDetails.toRole.trim();

        if ((emailcomposeDetails.to) && !emailRegex.test(emailcomposeDetails.to) && !nameRegex.test(emailcomposeDetails.to)) {
            newErrors.invalidTo = true;
        } else {
            newErrors.invalidTo = false;
        }

        const strippedText2 = emailcomposeDetails.body
            .replace(/<[^>]*>/g, " ")
            .replace(/\s+/g, " ")
            .trim();

        const words = strippedText2
            .split(" ")
            .filter(word => word.length > 0);

        if (words.length > WORD_LIMIT) {
            newErrors.wordLimitExceeded = true;
        } else {
            newErrors.wordLimitExceeded = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        if (isSubjectNew && !isDraft) {
            // console.log('this is done for darft  -1');

            sendEmail()
            // sendNewMail();
        } else {
            // console.log('this is done for darft  -2');
            updateMail();
        }
    }


    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else if (err.toLowerCase().includes('receiver email and body cannot be empty')) {
            setError(t('t219'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    const sendEmail = () => {
        setOpen2(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.get(`${web_url}/api/auth/researchers`, configToken).then((res3) => {

            const resEmail = res3.data[0].userEmail;

            let language = "English";
            let apiUrl = "";
            if (emailcomposeDetails.toRole === "Student") {
                apiUrl = `${web_url}/api/auth/students/${emailcomposeDetails.to}`
            } else if (emailcomposeDetails.toRole === "Teacher") {
                apiUrl = `${web_url}/api/auth/teachers/${emailcomposeDetails.to}`
            } else if (emailcomposeDetails.toRole === "Translator") {
                apiUrl = `${web_url}/api/auth/translators/${emailcomposeDetails.to}`
            }
            axios.get(apiUrl, configToken).then((response) => {
                if (emailcomposeDetails.toRole === "Student") {
                    language = response.data.preferredLanguage;
                } else {
                    language = "English";
                }

                const formData = new FormData();
                let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

                formData.append("sender", resEmail);
                formData.append("recipient", emailcomposeDetails.to);
                formData.append("subject", subject);
                formData.append("body", emailcomposeDetails.body);
                formData.append("language", "English");
                formData.append("isDraft", "FALSE");
                formData.append("type", "NONE");
                formData.append("translatedBody", "NA");
                formData.append("translatedSubject", "NA");
                formData.append("englishBody", "NA");
                formData.append("englishSubject", "NA");

                if (files && files.length > 0) {
                    files.forEach((file) => {
                        formData.append("attachments", file);
                    });
                }

                const config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${logDetails.token}`,
                    },
                };

                axios.post(`${web_url}/api/email-threads`, formData, config)
                    .then((response) => {
                        if (initialType === "draft") {
                            axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                                localStorage.setItem("refresh", `${Date.now()}`);
                                localStorage.setItem('draft type', "finished");
                                setInitialType('no')
                                setOpen2(false);
                                setOpen4(true);
                            }).catch((err) => {
                                setOpen2(false);
                                if (err.response.data.message) {
                                    if (err.response.data.message === "Message id not found!") {
                                        setEmailcomposeDetails({
                                            threadId: '',
                                            toRole: '',
                                            to: "",
                                            subject: '',
                                            body: '',
                                        })
                                    } else {
                                        handleClickOpenError("error occured")
                                    }
                                } else {
                                    handleClickOpenError("error occured")
                                }
                            })
                        } else {
                            setOpen2(false);
                            setOpen4(true);

                        }
                    })
                    .catch((err) => {
                        console.log("1", err)
                        if (err.response) {
                            // console.log(err.response)
                            if (err.response.data.error) {
                                handleClickOpenError(err.response.data.error);
                            } else if (err.response.data.message) {
                                handleClickOpenError(err.response.data.message);
                            } if (err.response.data.token) {
                                handleClickOpenError(err.response.data.token);
                            } else {
                                handleClickOpenError("An unknown error occured");
                            }

                        }
                        setOpen2(false);
                    })

            }).catch((err) => {
                setOpen2(false);
                // console.log("err", err)
                if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message);
                } else {
                    handleClickOpenError("Error occured")
                }
            })
        }).catch((err3) => {
            setOpen2(false);
            // console.log("err", err)
            if (err3.response.data.message) {
                handleClickOpenError(err3.response.data.message);
            } else {
                handleClickOpenError("Error occured")
            }
        })

    };

    const saveDraft = () => {
        setOpen3(false);
        if (emailcomposeDetails.toRole.trim() && emailcomposeDetails.body.trim()) {
            setErrors((prev) => ({ ...prev, noBody: false, noToRole: false }));
            if (isSubjectNew) {
                // console.log('this is done');

                setOpen2(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };

                axios.get(`${web_url}/api/auth/researchers`, configToken).then((resR) => {
                    const rEmail = resR.data[0].userEmail;
                    let language = "English";
                    let apiUrl = "";
                    if (emailcomposeDetails.toRole === "Student") {
                        apiUrl = `${web_url}/api/auth/students/${emailcomposeDetails.to}`
                    } else if (emailcomposeDetails.toRole === "Teacher") {
                        apiUrl = `${web_url}/api/auth/teachers/${emailcomposeDetails.to}`
                    } else if (emailcomposeDetails.toRole === "Translator") {
                        apiUrl = `${web_url}/api/auth/translators/${emailcomposeDetails.to}`
                    }

                    axios.get(apiUrl).then((responseNew) => {
                        if (emailcomposeDetails.toRole === "Student") {
                            language = responseNew.data.preferredLanguage;
                        } else {
                            language = "English";
                        }

                        const formData = new FormData();
                        let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

                        formData.append("sender", rEmail);
                        formData.append("recipient", emailcomposeDetails.to);
                        formData.append("subject", subject || " ");
                        formData.append("body", emailcomposeDetails.body);
                        formData.append("language", language);
                        formData.append("isDraft", "TRUE");
                        formData.append("type", "NONE");
                        formData.append("translatedBody", "NA");
                        formData.append("translatedSubject", "NA");
                        formData.append("englishBody", "NA");
                        formData.append("englishSubject", "NA");

                        if (files && files.length > 0) {
                            files.forEach((file) => {
                                formData.append("attachments", file);
                            });
                        }

                        const config = {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "Authorization": `Bearer ${logDetails.token}`,
                            },
                        };

                        axios.post(`${web_url}/api/email-threads`, formData, config)
                            .then((response) => {
                                if (initialType === "draft") {
                                    axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                                        localStorage.setItem("refresh", `${Date.now()}`);
                                        localStorage.setItem('draft type', "finished");
                                        setInitialType('no')
                                        setOpen2(false);
                                        setOpen5(true);
                                    }).catch((err) => {
                                        setOpen2(false);
                                        if (err.response.data.message) {
                                            if (err.response.data.message === "Message id not found!") {
                                                setEmailcomposeDetails({
                                                    threadId: '',
                                                    toRole: '',
                                                    to: "",
                                                    subject: '',
                                                    body: '',
                                                })
                                            } else {
                                                handleClickOpenError("error occured")
                                            }
                                        } else {
                                            handleClickOpenError("error occured")
                                        }
                                    })
                                } else {
                                    setOpen2(false);
                                    setOpen5(true);

                                }
                            })
                            .catch((err) => {
                                // console.log(err)
                                if (err.response) {
                                    // console.log(err.response)
                                    if (err.response.data.error) {
                                        handleClickOpenError(err.response.data.error);
                                    } else if (err.response.data.message) {
                                        handleClickOpenError(err.response.data.message);
                                    } if (err.response.data.token) {
                                        handleClickOpenError(err.response.data.token);
                                    } else {
                                        handleClickOpenError("An unknown error occured");
                                    }

                                }
                                setOpen2(false);
                            })

                    }).catch((err) => {
                        setOpen2(false);
                        // console.log("err", err)
                        if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } else {
                            handleClickOpenError("Error occured")
                        }
                    })
                }).catch((errR) => {
                    setOpen2(false);
                    // console.log("err", err)
                    if (errR.response.data.message) {
                        handleClickOpenError(errR.response.data.message);
                    } else {
                        handleClickOpenError("Error occured")
                    }
                })

            } else {
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };
                setOpen2(true);
                axios.get(`${web_url}/api/auth/researchers`, configToken).then((res2) => {
                    const rmailId = res2.data[0].userEmail;

                    const formData = new FormData();
                    let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

                    formData.append("sender", rmailId);
                    formData.append("body", emailcomposeDetails.body);
                    formData.append("language", "English");
                    formData.append("type", "NONE");
                    formData.append("isDraft", "TRUE");
                    formData.append("translatedBody", "NA");
                    formData.append("englishBody", "NA");


                    if (files && files.length > 0) {
                        files.forEach((file) => {
                            formData.append("attachments", file);
                        });
                    }

                    const config = {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": `Bearer ${logDetails.token}`,
                        },
                    };

                    axios.post(`${web_url}/api/email-threads/${emailcomposeDetails.threadId}/add-message`, formData, config)
                        .then((response) => {
                            if (initialType === "draft") {
                                axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                                    localStorage.setItem("refresh", `${Date.now()}`);
                                    localStorage.setItem('draft type', "finished");
                                    setInitialType('no')
                                    setOpen2(false);
                                    setOpen5(true);
                                }).catch((err) => {
                                    setOpen2(false);
                                    if (err.response.data.message) {
                                        if (err.response.data.message === "Message id not found!") {
                                            setEmailcomposeDetails({
                                                threadId: '',
                                                toRole: '',
                                                to: "",
                                                subject: '',
                                                body: '',
                                            })
                                        } else {
                                            handleClickOpenError("error occured")
                                        }
                                    } else {
                                        handleClickOpenError("error occured")
                                    }
                                })
                            } else {
                                setOpen2(false);
                                setOpen5(true);

                            }
                        })
                        .catch((err) => {
                            // console.log(err)
                            if (err.response) {
                                // console.log(err.response)
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } if (err.response.data.token) {
                                    handleClickOpenError(err.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            }
                            setOpen2(false);
                        })
                }).catch((err2) => {
                    // console.log(err)
                    if (err2.response) {
                        // console.log(err.response)
                        if (err2.response.data.error) {
                            handleClickOpenError(err2.response.data.error);
                        } else if (err2.response.data.message) {
                            handleClickOpenError(err2.response.data.message);
                        } if (err2.response.data.token) {
                            handleClickOpenError(err2.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                    setOpen2(false);
                })
            }
        } else if (!emailcomposeDetails.body) {
            setErrors((prev) => ({ ...prev, noBody: true }))
        } else if (!emailcomposeDetails.toRole) {
            setErrors((prev) => ({ ...prev, noToRole: true }))
        }

    };

    const updateMail = () => {
        setOpen2(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        axios.get(`${web_url}/api/auth/researchers`, configToken).then((resNewNowR) => {
            const resEmail = resNewNowR.data[0].userEmail;
            const formData = new FormData();
            let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

            formData.append("sender", resEmail);
            formData.append("body", emailcomposeDetails.body);
            formData.append("language", "English");
            formData.append("type", "NONE");
            formData.append("isDraft", "FALSE");
            formData.append("translatedBody", "NA");
            formData.append("englishBody", "NA");


            if (files && files.length > 0) {
                files.forEach((file) => {
                    formData.append("attachments", file);
                });
            }

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${logDetails.token}`,
                },
            };

            axios.post(`${web_url}/api/email-threads/${emailcomposeDetails.threadId}/add-message`, formData, config)
                .then((response) => {
                    if (initialType === "draft") {
                        axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                            localStorage.setItem("refresh", `${Date.now()}`);
                            localStorage.setItem('draft type', "finished");
                            setInitialType('no')
                            setOpen2(false);
                            setOpen4(true);
                        }).catch((err) => {
                            setOpen2(false);
                            if (err.response.data.message) {
                                if (err.response.data.message === "Message id not found!") {
                                    setEmailcomposeDetails({
                                        threadId: '',
                                        toRole: '',
                                        to: "",
                                        subject: '',
                                        body: '',
                                    })
                                } else {
                                    handleClickOpenError("error occured")
                                }
                            } else {
                                handleClickOpenError("error occured")
                            }
                        })
                    } else {
                        setOpen2(false);
                        setOpen4(true);

                    }
                })
                .catch((err) => {
                    console.log(err)
                    if (err.response) {
                        // console.log(err.response)
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } if (err.response.data.token) {
                            handleClickOpenError(err.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                    setOpen2(false);
                })
        }).catch((errNewNowR) => {
            // console.log(err)
            if (errNewNowR.response) {
                // console.log(err.response)
                if (errNewNowR.response.data.error) {
                    handleClickOpenError(errNewNowR.response.data.error);
                } else if (errNewNowR.response.data.message) {
                    handleClickOpenError(errNewNowR.response.data.message);
                } if (errNewNowR.response.data.token) {
                    handleClickOpenError(errNewNowR.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
            setOpen2(false);
        })
    }

    const [open2, setOpen2] = useState(false)

    const handleClose2 = () => {
        setOpen2(false);
    }

    const [open3, setOpen3] = useState(false)

    const handleClose3 = () => {
        setOpen3(false);
    }

    const [open4, setOpen4] = useState(false)

    const handleClose4 = () => {
        setOpen4(false);
        if (isXlOrLarger) {
            const mailRequest = {
                type: 'new',
                subject: 'nothing'
            };
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setFiles([])
            localStorage.setItem('threadId', JSON.stringify(mailRequest));
            localStorage.setItem("refresh", `${Date.now()}`);
            navigate('/desktop/researcher/mailbox')
        } else {
            navigate('/mobile/researcher/mailbox/inbox')
        }
    }

    const [openDraft, setOpenDraft] = useState(false)

    const handleCloseDraft = () => {
        setOpenDraft(false);
        if (isXlOrLarger) {
            const mailRequest = {
                type: 'new',
                subject: 'nothing'
            };
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setFiles([])
            localStorage.setItem('threadId', JSON.stringify(mailRequest));
            localStorage.setItem("refresh", `${Date.now()}`);
            navigate('/desktop/researcher/mailbox')
        } else {
            navigate('/mobile/researcher/mailbox/inbox')
        }
    }

    const [open5, setOpen5] = useState(false)

    const handleClose5 = () => {
        setOpen5(false);
        if (isXlOrLarger) {
            const mailRequest = {
                type: 'new',
                subject: 'nothing'
            };
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setFiles([])
            localStorage.setItem('threadId', JSON.stringify(mailRequest));
            localStorage.setItem("refresh", `${Date.now()}`);
            navigate('/desktop/researcher/mailbox')
        } else {
            navigate('/mobile/researcher/mailbox/inbox')
        }
    }

    const handleDeleteDraft = () => {
        setOpen2(true);
        if (initialType === "draft") {
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                localStorage.setItem("refresh", `${Date.now()}`);
                localStorage.setItem('draft type', "finished");
                setInitialType('no')
                setOpen2(false);
                setOpenDraft(true);
            }).catch((err) => {
                setOpen2(false);
                if (err.response.data.message) {
                    if (err.response.data.message === "Message id not found!") {
                        setEmailcomposeDetails({
                            threadId: '',
                            toRole: '',
                            to: "",
                            subject: '',
                            body: '',
                        })
                    } else {
                        handleClickOpenError("error occured")
                    }
                } else {
                    handleClickOpenError("error occured")
                }
            })
        } else {
            setOpen2(false);
        }
    }

    return (
        <>
            <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                <div className="flex items-center mt-[20px] lg:ml-[70px] xl:ml-[0px] justify-between">
                    <div className="xl:hidden flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "" && (emailRegex.test(emailcomposeDetails.to) || nameRegex.test(emailcomposeDetails.to))) {
                                setOpen3(true)
                            } else {
                                navigate('/mobile/researcher/mailbox/inbox')
                            }
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "" && (emailRegex.test(emailcomposeDetails.to) || nameRegex.test(emailcomposeDetails.to))) {
                                setOpen3(true)
                            } else {
                                navigate('/mobile/researcher/mailbox/inbox')
                            }
                        }} />
                        <p className={`font-bold ml-[10px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{isSubjectNew ? t('t233') : t('t260')}</p>
                    </div>
                    <div className="hidden xl:block flex justify-center items-center w-full">
                        <p className={`font-bold ml-[0px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[17px] 2xl:text-[23px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{isSubjectNew ? t('t233') : t('t260')}</p>
                    </div>
                </div>
                <div className="w-full flex items-center justify-center">
                    <div className="w-full md:w-[600px]">
                        <div className="flex gap-[10px] mt-[20px]">
                            <div className="group relative md:hidden border border-[#0E141F] rounded-md p-[8px]">
                                <MdAttachFile
                                    size={20}
                                    className="cursor-pointer"
                                    onClick={() => mobileFileInputRef.current?.click()} // Manually open file input
                                />
                                <input
                                    ref={mobileFileInputRef}
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[12px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t476")}
                                </div>
                            </div>
                            <div className="group relative hidden md:flex 2xl:hidden items-center justify-center border border-[#0E141F] rounded-md p-[8px]">
                                <MdAttachFile
                                    size={25}
                                    className="cursor-pointer"
                                    onClick={() => desktopFileInputRef.current?.click()} // Manually open file input
                                />
                                <input
                                    ref={desktopFileInputRef}
                                    type="file"
                                    multiple
                                    className="hidden "
                                    onChange={handleFileChange}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[14px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t476")}
                                </div>
                            </div>
                            <div className="group relative hidden 2xl:flex items-center justify-center border border-[#0E141F] rounded-md px-[12px]">
                                <MdAttachFile
                                    size={35}
                                    className="cursor-pointer"
                                    onClick={() => desktopFileInputRef.current?.click()} // Manually open file input
                                />
                                <input
                                    ref={desktopFileInputRef}
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[15px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t476")}
                                </div>
                            </div>

                            <div className="group relative md:hidden border border-[#0E141F] rounded-md p-[8px]">
                                <MdSave size={20} className="md:hidden "
                                    onClick={() => {
                                        if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "") {
                                            setOpen3(true)
                                        } else {
                                            handleClickOpenError("receiver email and body cannot be empty")
                                        }
                                    }} />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[12px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t232")}
                                </div>
                            </div>
                            <div className="group relative hidden md:flex 2xl:hidden items-center justify-center border border-[#0E141F] rounded-md p-[8px]">
                                <MdSave size={25} className="hidden md:block cursor-pointer" onClick={() => {
                                    if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "") {
                                        setOpen3(true)
                                    } else {
                                        handleClickOpenError("receiver email and body cannot be empty")
                                    }
                                }} />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[14px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t232")}
                                </div>
                            </div>
                            <div className="group relative hidden 2xl:flex items-center justify-center border border-[#0E141F] rounded-md px-[12px]">
                                <MdSave size={35} className="hidden md:block cursor-pointer" onClick={() => {
                                    if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "") {
                                        setOpen3(true)
                                    } else {
                                        handleClickOpenError("receiver email and body cannot be empty")
                                    }
                                }} />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[15px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t232")}
                                </div>
                            </div>

                            <div className="relative md:hidden w-full flex items-center justify-end">
                                <button className={`px-[10px] h-full flex items-center justify-center gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600]`}
                                    onClick={handleSend}><MdSend size={19} />{t('t116')}</button>
                            </div>
                            <div className="relative hidden md:flex w-full items-center justify-end">
                                <button className={`px-[10px] h-full flex items-center justify-center gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600]`}
                                    onClick={handleSend}><MdSend size={19} />{t('t116')}</button>
                            </div>
                            {
                                initialType === "draft" &&
                                <>
                                    <div className="relative md:hidden border border-[#0E141F] rounded-md p-[8px]">
                                        <MdDelete size={25} className="md:hidden" onClick={handleDeleteDraft} />
                                    </div>
                                    <div className="relative hidden md:block border border-[#0E141F] rounded-md p-[8px]">
                                        <MdDelete size={30} className="hidden md:block mr-[70px] xl:mr-[20px] cursor-pointer" onClick={handleDeleteDraft} />
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </div>

                {
                    isSubjectNew &&
                    <>
                        <div className="items-center mt-[20px] md:mt-[40px] xl:mt-[10px] flex h-[50px]  md:h-[60px] xl:h-[50px] 2xl:h-[60px] justify-center">
                            <Menu as="div" className="w-full md:w-[600px] relative inline-block text-left py-[20px]">
                                <div>
                                    <MenuButton
                                        className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${emailcomposeDetails.toRole === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                    >
                                        <p className="pr-[10px] text-gray-500">{t('t220')}:</p>
                                        {emailcomposeDetails.toRole.trim() === "" ? t('t293') : emailcomposeDetails.toRole}
                                        <ChevronDownIcon
                                            aria-hidden="true"
                                            className="absolute right-[10px] size-5 text-gray-700"
                                        />
                                    </MenuButton>
                                </div>

                                <MenuItems
                                    transition
                                    className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                    style={{
                                        width: '100%',
                                        maxHeight: '100px',
                                        overflowY: 'auto'
                                    }}
                                >
                                    <div className="py-1">
                                        {
                                            recepientArray.map((recepientSelect, index) => (
                                                <MenuItem key={index}>
                                                    <button
                                                        className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                        onClick={() => {
                                                            setEmailcomposeDetails((prev) => ({ ...prev, toRole: recepientSelect }))
                                                        }}
                                                    >
                                                        {recepientSelect}
                                                    </button>
                                                </MenuItem>
                                            ))
                                        }
                                    </div>
                                </MenuItems>
                            </Menu>
                        </div>

                        {errors.noToRole &&
                            <div className="flex items-center justify-center w-full">
                                <div className="w-full md:w-[600px]">
                                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t221')}</p>
                                </div>
                            </div>
                        }

                    </>
                }
                <div className="flex items-center justify-center">
                    <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                        <p className={`text-gray-500 text-[15px]`}>{t('t220')}:</p>
                        <input value={emailcomposeDetails.to} disabled={
                            (!(emailcomposeDetails.toRole) && isSubjectNew) || !isSubjectNew}

                            type="text" name="subject" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t222')}
                            onChange={(e) => {
                                setEmailcomposeDetails((prevState) => ({
                                    ...prevState, to: e.target.value.toLowerCase()
                                }))
                            }}
                        />
                    </div>
                </div>

                {errors.noTo &&
                    <div className="flex items-center justify-center w-full">
                        <div className="w-full md:w-[600px]">
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t223')}</p>
                        </div>
                    </div>
                }
                {errors.invalidTo &&
                    <div className="flex items-center justify-center w-full">
                        <div className="w-full md:w-[600px]">
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t443')}</p>
                        </div>
                    </div>
                }

                <div className="flex items-center justify-center">
                    <div className="mb-[10px] w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                        <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                        <input value={emailcomposeDetails.subject.trim() === "" && !isSubjectNew ? "(No subject)" : emailcomposeDetails.subject} disabled={!isSubjectNew} type="text" name="subject" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t225')}
                            onChange={(e) => {
                                setEmailcomposeDetails((prevState) => ({
                                    ...prevState, subject: e.target.value
                                }))
                            }}
                        />
                    </div>
                </div>

                {
                    files &&
                    <>
                        {
                            files.length > 0 &&
                            <>
                                <div className="md:flex md:justify-center md:items-center mb-[20px]">
                                    <div className="mt-[20px] md:pl-[100px] lg:pl-[200px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                        {files.map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center">
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName || file.name}</p>
                                                </div>
                                                <div className="pr-[10px]">
                                                    <MdClose onClick={() => removeFile(file)} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        }
                    </>
                }


                <div className="w-full flex items-center justify-center">
                    <div className="w-full md:w-[600px]">
                        <div className="justify-center items-center">
                            <ReactQuill
                                value={emailcomposeDetails.body}
                                onChange={handleChange}
                                modules={modules}
                                theme="snow"
                                placeholder={t('t225')}
                                className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                        </div>
                    </div>
                </div>

                {errors.noBody &&
                    <div className="flex items-center justify-center w-full">
                        <div className="w-full md:w-[600px]">
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t226')}</p>
                        </div>
                    </div>
                }


                {errors.wordLimitExceeded &&
                    <div className="flex items-center justify-center w-full">
                        <div className="w-full md:w-[600px]">
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t469')}</p>
                        </div>
                    </div>
                }
            </div >

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open3}
                onClose={handleClose3}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t218')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t215')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose3}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t217')}
                    </Button>
                    <Button
                        onClick={saveDraft}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t216')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open4}
                onClose={handleClose4}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t275')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose4}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open5}
                onClose={handleClose5}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t276')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose5}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openDraft}
                onClose={handleCloseDraft}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t408')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseDraft}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ResearcherEmailCompose;